import {signOut} from 'firebase/auth'
import {auth} from "../../fire";

export const salirAutenticacion = () => {

    signOut(auth).then((dox) => {

    })
}